import { IntlShape } from "react-intl";
import * as v from "valibot";

// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const SEMVER_REGEX =
  /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;

const semverMessage = (intl: IntlShape) =>
  intl.formatMessage({
    defaultMessage:
      "The version number is invalid. Please follow the semantic versioning guide here: https://semver.org/",
  });

// Be lenient about the conventional `v` prefix: accept "v1.0.0" as "1.0.0".
const stripLeadingV = (value: string) => value.replace(/^[vV]/, "");

export const semverSchema = (intl: IntlShape) =>
  v.pipe(
    v.string(),
    v.trim(),
    v.transform(stripLeadingV),
    v.nonEmpty(),
    v.regex(SEMVER_REGEX, semverMessage(intl)),
  );

export type SemverSchema = ReturnType<typeof semverSchema>;

// An empty string (the caller falls back to a default) or a valid semver.
// A `union([literal(""), semverSchema])` surfaces a generic "Expected string"
// error for invalid non-empty input; this reports the semver message instead.
export const optionalSemverSchema = (intl: IntlShape) =>
  v.pipe(
    v.string(),
    v.trim(),
    v.transform(stripLeadingV),
    v.check(
      (value) => value === "" || SEMVER_REGEX.test(value),
      semverMessage(intl),
    ),
  );

export type OptionalSemverSchema = ReturnType<typeof optionalSemverSchema>;
